module.exports = __webpack_public_path__ + "img/montageschulung_784x514.5c0ecd0d.jpg";